import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes'
import './styles/fonts'
import './styles/tokens.css'

/**
 * Entry для vite-react-ssg (routes-mode).
 *
 * Сайт строится из множества SEO-страниц (/, /digital/<role>,
 * /blog/<slug>, /services/<slug>). Каждый роут SSG генерирует в
 * отдельный dist/<path>/index.html с серверным HTML, видимым
 * Яндексу/Google без JavaScript.
 *
 * Routes определены в `src/routes.tsx`. ViteReactSSG сам оборачивает
 * приложение в HelmetProvider — двойную обёртку не делаем.
 */
export const createRoot = ViteReactSSG({ routes })

/**
 * Второстепенные шрифты (моноширинный, курсив, редкие подмножества) — когда
 * страница уже нарисована и браузер свободен. Здесь, а не в компоненте: точка
 * входа одна на все страницы, забыть её смонтировать нельзя. Почему они не в
 * общем CSS — см. styles/fonts-late.ts.
 */
if (typeof window !== 'undefined') {
  const loadLateFonts = () => void import('./styles/fonts-late')
  const whenIdle = () => {
    const ric = (window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number })
      .requestIdleCallback
    if (ric) ric(loadLateFonts, { timeout: 2000 })
    else window.setTimeout(loadLateFonts, 800)
  }
  if (document.readyState === 'complete') whenIdle()
  else window.addEventListener('load', whenIdle, { once: true })
}
